import PriorityUpdater from './priority_updater';

export default PriorityUpdater;
